import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { datesCompare } from '@lib/commons/util-functions/dates-compare.function';
import { formatDate } from '@lib/commons/util-functions/format-date.function';
import { formatPolicyNumber } from '@lib/commons/util-functions/format-policy-number.function';
import { calculatePolicyTerms, findActiveContracts } from '@lib/commons/util-functions/handle-contract.function';

import { ContractStatus, MemberContract } from '@lib/core/models/contract.interface';

import { InfoBadgeColors, InfoBadgeComponent } from '../info-badge/info-badge.component';

@Component({
  selector: 'shared-contract-item',
  standalone: true,
  imports: [MatIcon, MatTooltip, InfoBadgeComponent, InfoBadgeComponent, NgClass, TranslatePipe],
  templateUrl: './contract-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContractItemComponent {
  protected readonly formatDate = formatDate;
  protected readonly datesCompare = datesCompare;
  protected readonly calculatePolicyTerms = calculatePolicyTerms;
  protected readonly formatPolicyNumber = formatPolicyNumber;
  protected readonly contractStatus = ContractStatus;
  protected readonly todayDate = new Date();
  protected readonly badgeColors = InfoBadgeColors;

  type = input.required<'list-items' | 'status'>();
  contract = input<MemberContract>();
  contracts = input<MemberContract[]>();

  protected readonly showFullContractsList = signal<boolean>(false);

  protected readonly defaultContracts = computed((): MemberContract[] => findActiveContracts(this.contracts() ?? []));
  protected readonly policyTerms = computed(() => {
    if (this.contract()) {
      return this.calculatePolicyTerms(this.contract()!);
    }
    return 0;
  });

  protected toggleExpandedList() {
    return this.showFullContractsList.set(!this.showFullContractsList());
  }
}
